/* Registers the TownEye service worker for PWA installability.
 * The SW is install-only (no caching) — it never serves stale assets.
 * Safe to call in dev and prod; falls back silently if SW is unsupported.
 */
export function registerInstallSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Wait until after page load so the registration never blocks the UI thread.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Best-effort update check on each load.
        try { reg.update(); } catch (_) { /* ignore */ }
      })
      .catch((err) => {
        // Don't crash the app if SW registration fails (e.g. file://, http, blocked origin)
        // eslint-disable-next-line no-console
        console.warn("TownEye SW registration failed:", err);
      });
  });
}
